module.exports = __webpack_public_path__ + "img/b2-6.2f74c3e.png";